// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txncpM {
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: var(--radius-s);
  padding: var(--spacing-3);
  margin-bottom: var(--spacing-3);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.S67ma_ {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-3);
}

._1v5ME {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.V1jjCW {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
}

.d_xi4f {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-100);
  color: var(--text-neutral-dark);
}

.pLo_Sb:empty {
  display: none;
}

.pLo_Sb {
  display: flex;
  gap: var(--spacing-1-5);
  flex-wrap: wrap;
  border-top: 1px solid var(--stroke-neutral-subtle);
  padding-top: var(--spacing-2);
}

.pLo_Sb > button {
  flex: 1;
  min-width: 0;
}

/* Responsividade */
@media (max-width: 768px) {
  .S67ma_ {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-2);
  }

  .pLo_Sb {
    flex-direction: row;

    align-items: center;
    justify-content: space-between;
  }

  ._UIMv7 {
    width: 100%;
    min-width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/RechargeDetailsModal/components/PaymentInfo/PaymentInfo.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,kDAAkD;EAClD,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;;IAEnB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".container {\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-3);\n  margin-bottom: var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.amountSection {\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n  gap: var(--spacing-3);\n}\n\n.amountInfo {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.amountLabel {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n}\n\n.amountValue {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-100);\n  color: var(--text-neutral-dark);\n}\n\n.buttonSection:empty {\n  display: none;\n}\n\n.buttonSection {\n  display: flex;\n  gap: var(--spacing-1-5);\n  flex-wrap: wrap;\n  border-top: 1px solid var(--stroke-neutral-subtle);\n  padding-top: var(--spacing-2);\n}\n\n.buttonSection > button {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .amountSection {\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--spacing-2);\n  }\n\n  .buttonSection {\n    flex-direction: row;\n\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .paymentButton {\n    width: 100%;\n    min-width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `txncpM`,
	"amountSection": `S67ma_`,
	"amountInfo": `_1v5ME`,
	"amountLabel": `V1jjCW`,
	"amountValue": `d_xi4f`,
	"buttonSection": `pLo_Sb`,
	"paymentButton": `_UIMv7`
};
module.exports = ___CSS_LOADER_EXPORT___;
